import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { BaseService } from '@kodit/core/services';
import {
  AvansniRacunDto,
  AvansniRacuniClient,
  GetNewAvansniRacunForTransakcijuIzvodaQuery,
  VrstaRacuna,
} from '@kodit/core/data-api';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AvansniRacunZaTransakcijuIzvodaResolver
  extends BaseService
  implements Resolve<AvansniRacunDto> {
  constructor(private _client: AvansniRacuniClient, private _router: Router) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<AvansniRacunDto>
    | Promise<AvansniRacunDto>
    | AvansniRacunDto
    | null {
    return this._client
      .getNewForTransakcijuIzvoda(
        new GetNewAvansniRacunForTransakcijuIzvodaQuery({
          strankaId: this._router.getCurrentNavigation().extras.state.strankaId,
          datumPrometa: this._router.getCurrentNavigation().extras.state
            .datumPrometa,
          datumIzdavanja: this._router.getCurrentNavigation().extras.state
            .datumIzdavanja,
          transakcijaIzvodaId: this._router.getCurrentNavigation().extras.state
            .transakcijaIzvodaId,
          vrstaRacuna: route.data['vrstaRacuna'] as VrstaRacuna,
          stopaPdv: this._router.getCurrentNavigation().extras.state.stopaPDVa,
        })
      )
      .pipe(
        map((res) => res.data),
        catchError(this.handleError),
        finalize(() => {
          //this._configService.setIsBusy = false;
        })
      );
  }
}
